declare namespace $ {

	type $mol_select__value_bog_bzrl_app_filter_1 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_filter['district'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__Filter_bog_bzrl_app_filter_2 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__Trigger_icon_bog_bzrl_app_filter_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_filter['District_icon'] >
		,
		ReturnType< $mol_select['Trigger_icon'] >
	>
	type $mol_select__dictionary_bog_bzrl_app_filter_4 = $mol_type_enforce<
		({ 
			'all': string,
			'vahitovsky': string,
			'sovetsky': string,
			'novo_savinovsky': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_view__sub_bog_bzrl_app_filter_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_switch__value_bog_bzrl_app_filter_6 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_filter['rooms'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_bzrl_app_filter_7 = $mol_type_enforce<
		({ 
			'studio': string,
			'r1': string,
			'r2': string,
			'r3': string,
			'r4': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_view__sub_bog_bzrl_app_filter_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_bog_bzrl_app_filter_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_bzrl_app_filter_10 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_filter['price_from'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_bog_bzrl_app_filter_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__click_bog_bzrl_app_filter_12 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_filter['search'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_bzrl_app_filter_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_filter_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_bzrl_app_filter extends $mol_view {
		district( next?: string ): string
		District_icon( ): $mol_icon_chevron_down
		District( ): $mol_select
		District_block( ): $mol_view
		rooms( next?: string ): string
		Rooms( ): $mol_switch
		Rooms_block( ): $mol_view
		price_from( next?: string ): string
		Price_from( ): $mol_string
		Price_block( ): $mol_view
		search( next?: any ): any
		search_label( ): string
		Search( ): $mol_button_major
		Search_block( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=filter.view.tree.d.ts.map